import { create } from 'zustand';

import type { Answers, QuestionId, RoleAnswer, UseCaseAnswer } from '../lib/types';

export type RecordingWelcomeSurveyState = {
  answers: Answers;
  armSurvey: () => void;
  close: () => void;
  currentQuestion: QuestionId;
  disarm: () => void;
  goToRole: () => void;
  goToUseCase: () => void;
  isArmed: boolean;
  isOpen: boolean;
  open: () => void;
  reset: () => void;
  setRoleAnswer: (answer: RoleAnswer, otherText?: string) => void;
  setUseCaseAnswer: (answer: UseCaseAnswer) => void;
};

const initialState = {
  answers: {} as Answers,
  currentQuestion: 'role' as QuestionId,
  isArmed: false,
  isOpen: false,
};

export const useRecordingWelcomeSurveyStore = create<RecordingWelcomeSurveyState>((set) => ({
  ...initialState,

  armSurvey: () => set({ isArmed: true }),
  close: () => set({ ...initialState }),
  disarm: () => set({ isArmed: false }),
  goToRole: () => set({ currentQuestion: 'role' }),
  goToUseCase: () => set({ currentQuestion: 'use_case' }),

  open: () =>
    set((s) => {
      if (s.isOpen) return s;
      return { ...s, answers: {}, currentQuestion: 'role', isOpen: true };
    }),

  reset: () => set({ ...initialState }),

  setRoleAnswer: (answer, otherText) =>
    set((s) => {
      const nextAnswers: Answers = { ...s.answers, role: answer };
      if (answer === 'other' && otherText !== undefined) {
        nextAnswers.roleOtherText = otherText;
      } else {
        delete nextAnswers.roleOtherText;
      }
      return { answers: nextAnswers };
    }),

  setUseCaseAnswer: (answer) =>
    set((s) => ({
      answers: {
        ...s.answers,
        useCase: answer,
      },
    })),
}));
